<template>
  <div class="vm-page">
    <h2>Клиника</h2>
    
    <Card class="vm-form-card">
      <div v-if="loading" class="vm-card-layout"></div>
      <div class="logotype-select-wrap">
        <AvatarSelect
          :loading="uploadLoading"
          :img="organization.logo"
          @upload="loadImage"
          @remove="clearImage"
        />
      </div>
      <form @submit.prevent="submit">
        <div class="vm-form-group">
          <div class="vm-label-wrap">
            <label class="vm-label">Название клиники:</label>
          </div>
          <div class="vm-formfield-wrap">
            <FormField>
              <Input
                v-model="organization.title"
                :invalid="$v.organization.title.$error && !$v.organization.title.required"
                placeholder="Введите название..." />
              <Error v-if="$v.organization.title.$error && !$v.organization.title.required">
                Это обязательное поле
              </Error>
            </FormField>
          </div>
        </div>
        <div class="vm-form-group">
          <div class="vm-label-wrap">
            <label class="vm-label">Адрес страницы:</label>
          </div>
          <div class="vm-formfield-wrap">
            <FormField>
              <Input v-model="organization.slug" :placeholder="organization.id" />
            </FormField>
          </div>
        </div>
        <div class="vm-form-group">
          <div class="vm-label-wrap">
            <label class="vm-label">Адрес:</label>
          </div>
          <div class="vm-formfield-wrap">
            <FormField>
              <Input v-model="organization.address" placeholder="Введите адрес..." />
            </FormField>
          </div>
        </div>
        <div class="vm-form-group">
          <div class="vm-label-wrap">
            <label class="vm-label">Часовой пояс:</label>
          </div>
          <div class="vm-formfield-wrap">
            <FormField>
              <v-select
                class="vm-v-select"
                placeholder="Выберите часовой пояс..."
                v-model="organization.timezone"
                label="text"
                :options="timezones"
                :reduce="timezone => timezone.value"
                :clearable="false"
              />
            </FormField>
          </div>
        </div>
        <div class="vm-form-group">
          <div class="vm-label-wrap">
            <label class="vm-label">Сайт:</label>
          </div>
          <div class="vm-formfield-wrap">
            <FormField>
              <Input v-model="organization.website" placeholder="Введите сайт..." />
            </FormField>
          </div>
        </div>
        <div class="vm-form-group">
          <div class="vm-label-wrap">
            <label class="vm-label">Телефоны:</label>
          </div>
          <div class="vm-formfield-wrap">
            <FormField>
              <!--Input v-model="organization.phones" placeholder="Введите телефон..." /-->
              <Textarea v-model="organization.phones"
                :rows="5"
                :placeholder="'Введите телефон...'"
              />
            </FormField>
          </div>
        </div>
        <div class="vm-form-group">
          <div class="vm-label-wrap">
            <label class="vm-label">ИНН:</label>
          </div>
          <div class="vm-formfield-wrap">
            <FormField>
              <Input v-model="organization.inn" placeholder="Введите ИНН..." />
            </FormField>
          </div>
        </div>
        <div class="vm-form-group">
          <div class="vm-label-wrap">
            <label class="vm-label">КПП:</label>
          </div>
          <div class="vm-formfield-wrap">
            <FormField>
              <Input v-model="organization.kpp" placeholder="Введите КПП..." />
            </FormField>
          </div>
        </div>
        <div class="vm-form-group">
          <div class="vm-label-wrap">
            <label class="vm-label">ОГРН:</label>
          </div>
          <div class="vm-formfield-wrap">
            <FormField>
              <Input v-model="organization.ogrn" placeholder="Введите ОГРН..." />
            </FormField>
          </div>
        </div>
        <div class="vm-form-group">
          <div class="vm-label-wrap">
            <label class="vm-label">Время работы:</label>
          </div>
          <div class="vm-formfield-wrap">
            <FormField>
              <Textarea v-model="organization.worktime"
                :rows="5"
                :placeholder="'Например:\nПН-ПТ: 09:00 - 18:00\nСБ:09:00 - 15:00\nВС: ВЫХОДНОЙ'"
              />
            </FormField>
          </div>
        </div>
        <div class="vm-form-group">
          <div class="vm-label-wrap">
            <label class="vm-label">Доп. информация:</label>
          </div>
          <div class="vm-formfield-wrap">
            <FormField>
              <Textarea v-model="organization.info" 
                :rows="5"
                placeholder="Введите дополнительную информацию о клинике..."
              />
            </FormField>
          </div>
        </div>
        <div class="vm-form-group">
          <div class="vm-label-wrap">
            <label class="vm-label">Основной цвет: </label>
          </div>
          <div class="vm-formfield-wrap">
            <FormField>
              <b-form-input v-model="organization.front.primaryColor"  type="color"></b-form-input>
            </FormField>
          </div>
        </div>
        <div class="vm-form-group">
          <div class="vm-label-wrap">
            <label class="vm-label">Вспомогательный цвет:</label>
          </div>
          <div class="vm-formfield-wrap">
            <FormField>
              <b-form-input v-model="organization.front.secondaryColor" type="color"></b-form-input>
            </FormField>
          </div>
        </div>
        <div class="vm-groups">
          <div class="vm-form-group">
            <div class="vm-label-wrap">
              <label class="vm-label">Социальные сети:</label>
            </div>
            <div class="vm-formfield-wrap">
              <FormField>
                <Toggle v-model="showSocialInput" />
              </FormField>
            </div>
          </div>
          <div v-if="showSocialInput" class="vm-group-content">

            <div class="vm-form-group">
              <div class="vm-label-wrap">
                <label class="vm-label">ВКонтакте:</label>
              </div>
              <div class="vm-formfield-wrap">
                <FormField>
                  <Input v-model="organization.front.vk" placeholder="Введите ссылку..." />
                </FormField>
              </div>
            </div>

            <div class="vm-form-group">
              <div class="vm-label-wrap">
                <label class="vm-label">YouTube:</label>
              </div>
              <div class="vm-formfield-wrap">
                <FormField>
                  <Input v-model="organization.front.yt" placeholder="Введите ссылку..." />
                </FormField>
              </div>
            </div>

            <div class="vm-form-group">
              <div class="vm-label-wrap">
                <label class="vm-label">Twitter:</label>
              </div>
              <div class="vm-formfield-wrap">
                <FormField>
                  <Input v-model="organization.front.tw" placeholder="Введите ссылку..." />
                </FormField>
              </div>
            </div>

            <div class="vm-form-group">
              <div class="vm-label-wrap">
                <label class="vm-label">Facebook:</label>
              </div>
              <div class="vm-formfield-wrap">
                <FormField>
                  <Input v-model="organization.front.fb" placeholder="Введите ссылку..." />
                </FormField>
              </div>
            </div>

            <div class="vm-form-group">
              <div class="vm-label-wrap">
                <label class="vm-label">Одноклассники:</label>
              </div>
              <div class="vm-formfield-wrap">
                <FormField>
                  <Input v-model="organization.front.ok" placeholder="Введите ссылку..." />
                </FormField>
              </div>
            </div>

            <div class="vm-form-group">
              <div class="vm-label-wrap">
                <label class="vm-label">Telegram:</label>
              </div>
              <div class="vm-formfield-wrap">
                <FormField>
                  <Input v-model="organization.front.tg" placeholder="Введите ссылку..." />
                </FormField>
              </div>
            </div>

            <div class="vm-form-group">
              <div class="vm-label-wrap">
                <label class="vm-label">Instagram:</label>
              </div>
              <div class="vm-formfield-wrap">
                <FormField>
                  <Input v-model="organization.front.ig" placeholder="Введите ссылку..." />
                </FormField>
              </div>
            </div>
          </div>
        </div>
        <div class="vm-form-group">
          <div class="vm-label-wrap">
            <label class="vm-label">Услуги клиники:</label>
          </div>
          <div class="vm-formfield-wrap">
            <Services
              v-model="services"
              @add="add($event)"
              @remove="remove($event)"
            />
          </div>
        </div>
        <div class="vm-form-group">
          <div class="vm-label-wrap">
            <label class="vm-label">Позиция клиники:</label>
          </div>
          <div class="vm-formfield-wrap">
            <yandex-map class="map"
              @click="setCoords"
              :coords="center"
              :controls="[]"
              :zoom="14">
              <ymap-marker v-if="organization.front.coords"
                :coords="organization.front.coords"
                :icon="markerIcon"
                marker-id="123" 
                hint-content="Наша клиника!" 
              />
            </yandex-map>
          </div>
        </div>
        <div class="form-button">
          <Button @click="reset" type="button" vm-outline>Отменить</Button>
          <Button class="vm-submit-button" type="submit">Cохранить</Button>
        </div>
      </form>
    </Card>
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators';
import { uploadImageApi } from '@app/services';
import Card from '@app/components/uikit/Card';
import Input from '@app/components/uikit/Input';
import Textarea from '@app/components/uikit/Textarea';
import FormField from '@app/components/uikit/FormField';
import Error from '@app/components/uikit/Error';
import Button from '@app/components/uikit/VMButton';
import AvatarSelect from '@app/components/uikit/AvatarSelect';
import { yandexMap, ymapMarker } from 'vue-yandex-maps';

import helper from '@app/services/helper';
import MedicalIcon from '@app/assets/medical-pin.svg';
import { isEmpty } from 'lodash';
import Toggle from '@app/components/uikit/Toggle';
import Services from '../components/Services';

export default {
  components: {
    Services,
    Card,
    Input,
    Textarea,
    FormField,
    Error,
    Button,
    Toggle,
    AvatarSelect,
    yandexMap,
    ymapMarker
  },
  data: () => ({
    services: [],
    showSocialInput: false,
    markerIcon: {
      layout: 'default#imageWithContent',
      imageHref: MedicalIcon,
      imageSize: [64, 64],
      imageOffset: [-32, -64],
    },
    center: [
      59.937500,
      30.308611,
    ],
    coords: null,
    uploadLoading: false,
    timezones: [
      { text: '(UTC+02:00) Калининград', value: 'Europe/Kaliningrad' },
      { text: '(UTC+03:00) Москва', value: 'Europe/Moscow' },
      { text: '(UTC+04:00) Астрахань', value: 'Europe/Astrakhan' },
      { text: '(UTC+04:00) Ульяновск', value: 'Europe/Ulyanovsk' },
      { text: '(UTC+04:00) Самара', value: 'Europe/Samara' },
      { text: '(UTC+04:00) Саратов', value: 'Europe/Saratov' },
      { text: '(UTC+04:00) Волгоград', value: 'Europe/Volgograd' },
      { text: '(UTC+05:00) Екатеринбург', value: 'Asia/Yekaterinburg' },
      { text: '(UTC+06:00) Омск', value: 'Asia/Omsk' },
      { text: '(UTC+07:00) Новосибирск', value: 'Asia/Novosibirsk' },
      { text: '(UTC+07:00) Красноярск', value: 'Asia/Krasnoyarsk' },
      { text: '(UTC+07:00) Барнаул', value: 'Asia/Barnaul' },
      { text: '(UTC+07:00) Томск', value: 'Asia/Tomsk' },
      { text: '(UTC+07:00) Новокузнецк', value: 'Asia/Novokuznetsk' },
      { text: '(UTC+08:00) Иркутск', value: 'Asia/Irkutsk' },
      { text: '(UTC+09:00) Якутск', value: 'Asia/Yakutsk' },
      { text: '(UTC+09:00) Чита', value: 'Asia/Chita' },
      { text: '(UTC+10:00) Владивосток', value: 'Asia/Vladivostok' },
      { text: '(UTC+11:00) Магадан', value: 'Asia/Magadan' },
      { text: '(UTC+12:00) Анадырь', value: 'Asia/Anadyr' }
    ],
    logoBase64: null,
    organization: {
      address: null,
      city: null,
      info: null,
      inn: null,
      kpp: null,
      logo: null,
      ogrn: null,
      okato: null,
      phones: null,
      slug: null,
      timezone: null,
      title: null,
      uuid: null,
      website: null,
      worktime: null,
      front: null,
    },
  }),
  validations: {
    organization: {
      title: { required }
    }
  },
  created() {
    this.reset();
  },
  computed: {
    loading() {
      return this.$store.state.clinic.loading;
    }
  },
  methods: {
    add(service) {
      this.services.push(service);
    },
    remove(uuid) {
      const index = this.services.findIndex(s => s.uuid === uuid);
      this.services.splice(index, 1);
    },
    setCoords(event) {
      const coords = event.get('coords');
      const front = { ...this.organization.front, coords };
      this.organization.front = front;
    },
    unmaskText(text) {
      const defaultDelimiters = /[-!$%^&*()_+|~=`{}[\]:";'<>?,./\\ ]/;
      return text
        ? String(text).replace(new RegExp(defaultDelimiters, 'g'), '')
        : text;
    },
    async submit() {
      this.$v.organization.$touch();
      if (this.$v.organization.$invalid) {
        return;
      }
      const phones = this.organization.phones;
      if (!this.showSocialInput) {
        this.removeSocial(this.organization.front);
      }
      const front = { ...this.organization.front, services: this.services };
      await this.$store.dispatch('clinic/saveOrganization', {
        ...this.organization,
        phones,
        front,
      });
    },
    hasSocial(front) {
      return !!(front.fb || front.ig || front.ok || front.tg || front.tw || front.vk || front.yt);
    },
    removeSocial(front) {
      delete front.fb;
      delete front.ig;
      delete front.ok;
      delete front.tg;
      delete front.tw;
      delete front.vk;
      delete front.yt;
    },
    reset() {
      this.organization = { ...this.$store.state.clinic.organization.form };
      if (!isEmpty(this.organization.front)) {
        this.showSocialInput = this.hasSocial(this.organization.front);
        this.organization.front.primaryColor =
          this.organization.front.primaryColor ? this.organization.front.primaryColor : '#8c30da';
        this.organization.front.secondaryColor =
          this.organization.front.secondaryColor ? this.organization.front.secondaryColor : '#8c30da';
      }
      this.services = !!this.organization?.front?.services ? this.organization.front.services : [];
      this.center = this.organization.front.coords ? this.organization.front.coords : this.center;
    },
    async clearImage() {
      this.uploadLoading = true;
      await this.$store.dispatch('clinic/saveLogo', '');
      this.organization.logo = '';
      this.uploadLoading = false;
    },
    async loadImage(file) {
      await this.uploadImage(file);
    },
    async uploadImage(file) {
      this.uploadLoading = true;
      const formData = new FormData();
      formData.append('file', file);
      const logo = await uploadImageApi.upload(formData);
      await this.$store.dispatch('clinic/saveLogo', logo);
      this.organization.logo = logo;
      this.uploadLoading = false;
    },
    getImageUrl(image) {
      return helper.getImageUrl(image);
    }
  }
};
</script>

<style lang="scss" scoped>
.vm-form-card {
  display: flex;
  padding: 36px;
}
.logotype-select-wrap {
  margin-bottom: 24px;
  display: flex;
  justify-content: center;
}
form {
  flex: auto;
}
h2 {
  text-transform: uppercase;
  text-align: center;
  font-size: 2rem;
  margin-bottom: 24px;
  font-weight: 500;
}
.vm-card-layout {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  border-radius: 4px;
  background-color: rgba(255, 255, 255, 0.6);
  z-index: 4;
}
.vm-label {
  color: #B1B1B1;
  margin: 0;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  min-height: 36px;
}
.vm-form-group {
  display: flex;
}
.vm-form-header {
  text-align: right;
  font-weight: 500;
  color: #8C30DA;
  text-transform: uppercase;
  font-size: 20px;
  margin-bottom: 24px;
}
.vm-form-header,
.vm-label-wrap {
  width: 180px;
  flex: 0 0 180px;
}
.vm-label-wrap {
  text-align: right;
  margin-right: 12px;
  padding-bottom: 24px;
}
.vm-formfield-wrap {
  flex: auto;
  align-self: center;
}
.form-button {
  display: flex;
  justify-content: flex-end;
}
.vm-submit-button {
  margin-left: 12px;
}
.map {
  display: block;
  height: 400px;
}
.form-button {
  margin-top: 24px;
}
@media (max-width: 1508px) {
  .vm-page {
    padding: 0 24px;
  }
}
@media (max-width: 900px) {
  .vm-form-card {
    flex-wrap: wrap;
  }
  .logotype-select-wrap,
  form {
    width: 100%;
  }
}
@media (max-width: 700px) {
  .vm-label {
    justify-content: flex-start;
    line-height: 1;
    min-height: auto;
    margin-bottom: 6px;
  }
  .vm-form-group {
    flex-direction: column;
  }
  .vm-label-wrap {
    padding: 0;
    margin: 0;
  }
  .vm-formfield-wrap,
  .vm-label-wrap {
    width: 100%;
  }
}
</style>
